import { z } from 'zod';

import { CustomerDeliveryChannelSchema } from './customer-delivery-channel.schema.js';

export const CheckoutChecklistItemSchema = z.object({
  itemKey: z.string().trim().min(1),
  checked: z.boolean(),
  notes: z.string().max(500).nullable().optional(),
});

export const UpdateServiceOrderCheckoutCaptureBodySchema = z.object({
  checkoutChecklistSnapshot: z.array(CheckoutChecklistItemSchema),
  sendToTitularApp: z.boolean().optional(),
  deliveryChannel: CustomerDeliveryChannelSchema.optional(),
});

export type UpdateServiceOrderCheckoutCaptureBody = z.infer<
  typeof UpdateServiceOrderCheckoutCaptureBodySchema
>;

export const UpdateServiceOrderCheckoutCaptureResponseSchema = z.object({
  serviceOrderId: z.uuid(),
});

export type UpdateServiceOrderCheckoutCaptureResponse = z.infer<
  typeof UpdateServiceOrderCheckoutCaptureResponseSchema
>;

export const SERVICE_ORDER_PHOTO_KINDS = ['DAMAGE_IN', 'DAMAGE_OUT'] as const;

export const AddServiceOrderPhotoBodySchema = z.object({
  kind: z.enum(SERVICE_ORDER_PHOTO_KINDS).default('DAMAGE_OUT'),
  storageUrl: z.string().trim().min(1).max(500),
  caption: z.string().max(500).nullable().optional(),
});

export type AddServiceOrderPhotoBody = z.infer<typeof AddServiceOrderPhotoBodySchema>;

export const AddServiceOrderPhotoResponseSchema = z.object({
  photoId: z.uuid(),
});

export type AddServiceOrderPhotoResponse = z.infer<typeof AddServiceOrderPhotoResponseSchema>;

export const SignServiceOrderDeliveryTermBodySchema = z.object({
  signedByName: z.string().trim().min(1).max(200),
  storageUrl: z.string().trim().min(1).max(500),
});

export type SignServiceOrderDeliveryTermBody = z.infer<
  typeof SignServiceOrderDeliveryTermBodySchema
>;

export const SignServiceOrderDeliveryTermResponseSchema = z.object({
  signatureId: z.uuid(),
});

export type SignServiceOrderDeliveryTermResponse = z.infer<
  typeof SignServiceOrderDeliveryTermResponseSchema
>;
